import i from 'inflect';
import get from 'lodash/get';
import set from 'lodash/set';

/**
 * @param {...string} attributes
 * @return {function(constructor: Function)}
 */
export function AccessorsMutatorsDecorator(...attributes) {

    return (constructor) => {

        attributes.forEach((name) => {

            Object.defineProperty(constructor.prototype, name, {
                get: function () {
//                    if (this.attributes[ name ] !== undefined) {
                    return this.accessAttribute(name, this.attributes[ name ])
//                    }
                },
                set: function (value) {

                    this.attributes[ name ] = this.mutateAttribute(name, value);
                },
                enumerable: true
            });
        });
    };
}

export class Model {

    /**
     * @param {Object[]} array
     * @returns {{new this}[]}
     */
    static factory(array) {

        return Array.isArray(array) && array.length ? array.map((attributes) => new this(attributes)) : [];
    }

    /**
     * @type {string}
     */
    static get primaryKey() {

        return 'id';
    }

    /**
     * @type {*|null}
     */
    get primaryKey() {

        return this[ this.constructor.primaryKey ] || null;
    }

    /**
     * @type {boolean}
     */
    get exists() {

        return !!this.primaryKey;
    }

    /**
     * @param {string} name
     * @return {string}
     * @protected
     */
    makeGetterName(name) {

        return `get${i.camelize(name)}`;
    }

    /**
     * @param {string} name
     * @return {string}
     * @protected
     */
    makeSetterName(name) {

        return `set${i.camelize(name)}`
    }

    /**
     * @param {string} property
     * @param {*} value
     * @return {*}
     * @protected
     */
    accessAttribute(property, value) {

        const getter = this.makeGetterName(property);

        if (typeof this[ getter ] === 'function') {

            value = this[ getter ](value);
        }

        return value;
    }

    /**
     * @param {string} property
     * @param {*} value
     * @return {*}
     * @protected
     */
    mutateAttribute(property, value) {

        const setter = this.makeSetterName(property);

        if (typeof this[ setter ] === 'function') {

            value = this[ setter ](value);
        }

        return value;
    }

    /**
     * @param {Object.<string, *>} attributes
     */
    constructor(attributes = {}) {

        this.attributes = {};
        this.fill(attributes);
    }

    /**
     * @param {Object.<string, *>} attributes
     */
    fill(attributes = {}) {
        
        Object.keys(attributes)
              .forEach((name) => {

                  this.attributes[ name ] = this.mutateAttribute(name, attributes[ name ]);
              });
    }

    /**
     * @param {string} path
     * @returns {*}
     */
    getFormat(path) {

        const formatFunc = `format${i.camelize(path)}`;

        return formatFunc in this ? this[ formatFunc ]() : this.get(path);
    }
    
    /**
     * @param {string} path
     * @returns {*}
     */
    get (path) {

        return path in this ? this[ path ] : get(this, path);
    }

    /**
     * @param {string} path
     * @param {*} value
     */
    set (path, value) {

        if (path in this) {

            this[ path ] = value;
        } else {

            set(this, path, value);
        }
    }

    /**
     * @param {Model} other
     * @returns {boolean}
     */
    equal(other) {

        return other instanceof this.constructor && this.primaryKey === other.primaryKey;
    }

    /**
     * @param {Model} other
     * @throws {Error}
     */
    fresh(other) {

        if (!this.equal(other)) {

            throw new Error("Model can be refreshed only from equal model.");
        }

        this.fill(other.toObject());
    }

    /**
     * @param {...string=} keys
     * @return {Model}
     */
    copy(...keys) {

        return new this.constructor(JSON.parse(JSON.stringify(this.toObject(...keys))));
    }

    /**
     * @param {...string=} keys
     * @return {Model}
     */
    copyExcept(...keys) {

        return new this.constructor(JSON.parse(JSON.stringify(this.toObjectExcept(...keys))));
    }

    /**
     * @param {string} name
     */
    delete(name) {

        delete this.attributes[ name ];
    }

    /**
     * @param {...string} keys
     * @return {Object.<string, *>}
     */
    toObject(...keys) {

        const obj = {};

        keys = keys.length ? keys : Object.keys(this.attributes);
        keys.forEach((key) => obj[ key ] = this[ key ]);

        return obj;
    }

    /**
     * @param {...string} keys
     * @return {Object.<string, *>}
     */
    toObjectExcept(...keys) {

        if (keys.length) {

            keys = Object.keys(this.attributes).filter((key) => keys.indexOf(key) === -1);
        }

        return this.toObject(...keys);
    }

    /**
     * @return {Object.<string, *>}
     */
    toJSON() {

        return this.toObject();
    }
}


// WEBPACK FOOTER //
// ./src/helpers/model.js